<template lang="pug">
    v-card( dark )
        v-card-text.py-5
            h1.display-2 Modulo de Adquisiciones
            p.subheading.ma-0 Abastecimiento, compras y proveedores
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'index-component',
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    created: function() {
        this.setTitleTopBar('Bienvenido')
    },
}
</script>